import classNames from 'classnames';
import PropTypes from 'prop-types';
import settings from '/@/core/settings';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const types = /** @type {const} */ [
    'info',
    'locked-corn',
    'no-share-corn',
    'no-share-soy',
    'not-found',
    'library-not-found',
    'offline',
    'send-email',
    'send-email-success',
    'success',
    'success-corn',
    'working',
    'working-corn',
    'working-soy',
    'crop-monitoring-not-found',
    'warning-corn',
    'error',
    'error2',
];

const countByType = {
    info: 3,
    error: 2,
    error2: 2,
};

/** @param {typeof propTypes} props  */
function Drawing(props) {
    const { type, size, color, title, subtitle } = props;
    const asset = [type, Math.floor(Math.random() * (countByType[type] || 1)) + 1].join('-');

    return (
        <div className={classNames(styles.root, styles[color])}>
            <div
                className={classNames(
                    styles.image,
                    settings.app.theme === 'expertobayer' ? styles[`experto-bayer-${asset}`] : styles[asset],
                    settings.app.theme === 'expertobayer'
                        ? styles[`experto-bayer-size-${size}`]
                        : styles[`size-${size}`]
                )}
                style={{ ...props.style }}
            />
            {title && (
                <Title
                    bolder={props.coloredTitle}
                    theme={props.coloredTitle ? settings.app.theme : undefined}
                    size='xl'
                    className={styles.title}
                >
                    {title}
                </Title>
            )}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
    );
}

const propTypes = {
    type: PropTypes.oneOf(types).isRequired,
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'responsive']),
    color: PropTypes.oneOf(['black', 'white']),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    subtitle: PropTypes.string,
};

Drawing.propTypes = propTypes;
Drawing.defaultProps = {
    size: 'md',
    color: 'black',
};

export default Drawing;
